import { render, staticRenderFns } from "./mineData.vue?vue&type=template&id=fb255da0&scoped=true"
import script from "./mineData.vue?vue&type=script&lang=js"
export * from "./mineData.vue?vue&type=script&lang=js"
import style0 from "./mineData.vue?vue&type=style&index=0&id=fb255da0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb255da0",
  null
  
)

export default component.exports